import { render } from "./QuoteFailModal.vue?vue&type=template&id=35d6b160"
import script from "./QuoteFailModal.vue?vue&type=script&lang=js"
export * from "./QuoteFailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__